import type { FaireProductEntity } from "../../entity_types/product";

export const p_9x9s3syfgx: FaireProductEntity = {
  token: "p_9x9s3syfgx",
  type: "product",
  name: "Dutch Oven BBQ Pro Pack Gift Box",
  brandToken: "b_vceppzx3jv",
  brandName: "The Dutch Oven Smokehouse",
  imageUrl:
    "https://cdn.faire.com/fastly/bbe54a89acd8e379d653bbe0a145ba594967347805e91a7726bc880bbdeaaf16.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eb533c4e42b43109e82b96ea4c79b99afeb00cccb131a9ebca0f1dbf4e9e073e.jpeg",
    "https://cdn.faire.com/fastly/a76f4687a3517d8f951c38aa81079df3c3f66980c026c046ffa0882b651c23de.jpeg",
    "https://cdn.faire.com/fastly/e9a4b76543f576fba410b6dc6223c65c1d57196b44ad6dd7170d577f63792da3.jpeg",
    "https://cdn.faire.com/fastly/d1bed3a42d7e48370f9da4e0c46c329981508b5460c59f8838bb0587b1a91126.jpeg",
    "https://cdn.faire.com/fastly/3b857a6ed97f833d7523121f089f2aa050d9d14ee478ff71f2bc74965a56ed70.jpeg",
    "https://cdn.faire.com/fastly/af0d657f60f9ee1092e1a0538710926154fe7c868454194e64f873dac6ae6561.jpeg",
    "https://cdn.faire.com/fastly/20f2f28cab661c933df84628906cb83c8d201992641bc01531f76ac143ba87f1.jpeg",
  ],
  priceDollars: 28.5,
  description:
    "This makes a great gift for BBQ pros! Great for competion style professionals or top notch backyard bbq aficionados. Includes 1 each of our 3 main BBQ rubs: Chuckbox brisket rub, Belle Fourche BBQ chicken and pork rub, and our new Motherlode hot honey rub. All packaged in an attractive gift box ready for sharing!",
  tags: [],
  msrpDollars: 49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:15.948Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
